import { useTranslation } from 'react-i18next'

import Icon from '../icon'

const SecuritySection = () => {
  const { t } = useTranslation('homeV2')

  const CARDS = [
    {
      icon: <Icon id="bank-transfer" width="69" height="61" />,
      title: t('bank-transfers'),
      subtitle: t('no-cost'),
    },
    {
      icon: <Icon id="prepaid-cards" width="56" height="57" />,
      title: t('prepaid-cards'),
      subtitle: t('not-to-deposit'),
    },
    {
      icon: <Icon id="credit-cards" width="67" height="59" />,
      title: t('credit-debit'),
      subtitle: t('popular-options'),
    },
    {
      icon: <Icon id="electronic-wallets" width="70" height="50" />,
      title: t('e-wallet'),
      subtitle: t('virtual-transactions'),
    },
  ]

  return (
    <div className="pt-[78px] pb-6 px-6 xl:max-w-screen-xl xl:mx-auto xl:my-0 xl:pt-32 xl:pb-12 xl:px-6">
      <h2 className="text-[15px] font-Geometr706-BlkCn-BT text-yellow text-center uppercase xl:text-xl">
        {t('money-protected')}
      </h2>
      <h2 className="text-3xl font-Geometr706-BlkCn-BT text-txt text-center uppercase mt-2 xl:text-[35px]">
        {t('more-security')}
      </h2>
      <p className="text-[15px] text-txt text-center mt-4 xl:max-w-[800px] xl:mt-4 xl:mb-0 xl:mx-auto">
        {t('browse-participate')}
      </p>
      <div className="grid grid-cols-[1fr_1fr] grid-rows-[1fr_1fr] gap-3 mt-14 xl:grid-cols-[repeat(4,1fr)] xl:grid-rows-[1fr] xl:gap-[100px]">
        {CARDS.map((card, index) => (
          <div className="flex flex-col items-center" key={index}>
            <div className="w-full h-[72px] flex justify-center items-center [&>svg]:text-[#0e091e] dark:[&>svg]:text-[#f2f2fa]">
              {card.icon}
            </div>
            <h3 className="text-xl font-Geometr706-BlkCn-BT text-txt text-center uppercase mt-5">
              {card.title}
            </h3>
            <p className="text-[15px] text-txt text-center mt-2">
              {card.subtitle}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SecuritySection
